import type { AssistantToolCatalogAnyDefinition } from '@/features/assistant/tool-catalog'
import type { AssistantToolErrorShape } from '@/features/assistant/tool-errors'
import { serializeAssistantTransportValue } from '@/features/assistant/transport-value'
import { LOCAL_AGENT_PROTOCOL_VERSION } from '@/features/assistant/bridge/local-agent-protocol'

export interface McpToolDescriptor {
  name: string
  description: string
  inputSchema: unknown
  annotations?: {
    title?: string
    readOnlyHint?: boolean
    openWorldHint?: boolean
  }
  _meta?: {
    protocolVersion: string
    kind: AssistantToolCatalogAnyDefinition['kind']
    transport: AssistantToolCatalogAnyDefinition['transport']
    preconditions: string[]
    sideEffects: string[]
    supportsProgress: boolean
    supportsCancellation: boolean
  }
}

export interface McpToolResultEnvelope {
  content: Array<{
    type: 'text'
    text: string
  }>
  structuredContent?: unknown
  isError?: boolean
}

export function serializeAssistantToolDefinitionToMcp(
  definition: AssistantToolCatalogAnyDefinition,
): McpToolDescriptor {
  return {
    name: definition.name,
    description: definition.description,
    inputSchema: definition.inputSchema,
    annotations: {
      title: definition.name,
      readOnlyHint: definition.kind === 'query',
      openWorldHint: definition.transport === 'browser-only',
    },
    _meta: {
      protocolVersion: LOCAL_AGENT_PROTOCOL_VERSION,
      kind: definition.kind,
      transport: definition.transport,
      preconditions: [...(definition.preconditions ?? [])],
      sideEffects: [...(definition.sideEffects ?? [])],
      supportsProgress: definition.supportsProgress ?? false,
      supportsCancellation: definition.supportsCancellation ?? false,
    },
  }
}

export async function serializeAssistantToolResultToMcp(
  result: unknown,
): Promise<McpToolResultEnvelope> {
  const serializedResult = await serializeAssistantTransportValue(result)
  return {
    content: [
      {
        type: 'text',
        text: JSON.stringify(serializedResult, null, 2),
      },
    ],
    structuredContent: serializedResult,
  }
}

export function serializeAssistantToolErrorToMcp(
  error: AssistantToolErrorShape,
): McpToolResultEnvelope {
  return {
    content: [
      {
        type: 'text',
        text: JSON.stringify(error, null, 2),
      },
    ],
    structuredContent: error,
    isError: true,
  }
}
